var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var SkillIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 62,
    glyphOffsetY: -3
  }), React.createElement("path", {
    d: "M32 0.608643L41.8087 20.6434L63.9304 23.5652L48.0695 39.0086L51.6174 61.1304L32 50.6956L12.3826 61.1304L16.1391 39.2173L0.0695496 23.5652L22.1913 20.4347L32 0.608643ZM40.5565 45.8956L38.8869 36.2956L45.7739 29.4086L36.1739 27.9478L32 19.3913L27.6174 28.1565L18.0174 29.6173L24.9043 36.5043L23.2348 46.1043L31.7913 41.513L40.5565 45.8956Z"
  }));
};
export var SkillIconGlyph = function (props) {
  return React.createElement(SkillIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};